export const billingExplorerChartKeyGenerator = (
  field?: string,
  label?: string | null,
) => {
  const keyLabel = label ? `${label} - ` : "";
  return `${keyLabel} ${field}`.trim();
};
